import React from 'react';
import { SectionReveal } from '../components/SectionReveal';
import { ArrowRightIcon } from 'lucide-react';
const PURCHASE_URL = 'https://ahorro-total-2.myshopify.com/cart/44075741741116:1';
export function ExampleSection() {
  return <section className="relative w-full bg-brand-darker py-20 md:py-28 overflow-hidden" data-id="element-58">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-mid/50 to-brand-darker" data-id="element-59" />

      <div className="relative z-10 max-w-4xl mx-auto px-4" data-id="element-60">
        <SectionReveal data-id="element-61">
          <p className="text-4xl mb-4 text-center" data-id="element-62">📉</p>
          <div className="flex justify-center mb-6" data-id="element-63">
            <div className="inline-flex items-center gap-2 bg-blue-500/10 border border-blue-500/25 rounded-full px-5 py-2" data-id="element-64">
              <span className="text-blue-400 font-body text-sm font-semibold uppercase tracking-wider" data-id="element-65">
                Ejemplo real aplicando la guía
              </span>
            </div>
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white text-center mb-4 uppercase tracking-[-0.02em]" data-id="element-66">
            Mirá lo que puede pasar con tu factura:
          </h2>
        </SectionReveal>

        <SectionReveal delay={0.15} data-id="element-67">
          <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="block no-underline" data-id="element-68">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-0 mt-12 mb-10 relative" data-id="element-69">
              {/* ANTES card */}
              <div className="bg-gradient-to-br from-red-950/80 to-red-900/40 border-2 border-brand-red/40 rounded-xl md:rounded-r-none p-8 md:p-10 text-center relative overflow-hidden" data-id="element-70">
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-brand-red" data-id="element-71" />
                <p className="font-heading font-bold text-xl text-brand-red uppercase tracking-widest mb-4" data-id="element-72">
                  ANTES
                </p>
                <p className="font-heading font-bold text-5xl sm:text-6xl md:text-7xl text-white mb-2" data-id="element-73">
                  $97.540
                </p>
                <p className="text-red-300 font-body text-sm" data-id="element-74">
                  Factura mensual promedio
                </p>
              </div>

              {/* Arrow between cards (desktop) */}
              <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20 w-14 h-14 bg-[#3b82f6] rounded-full items-center justify-center shadow-lg shadow-blue-500/30" data-id="element-75">
                <ArrowRightIcon className="w-7 h-7 text-white" data-id="element-76" />
              </div>

              {/* DESPUÉS card */}
              <div className="bg-gradient-to-br from-green-950/80 to-green-900/40 border-2 border-[#10b981] rounded-xl md:rounded-l-none p-8 md:p-10 text-center relative overflow-hidden" data-id="element-77">
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-brand-green" data-id="element-78" />
                <p className="font-heading font-bold text-xl text-brand-green uppercase tracking-widest mb-4" data-id="element-79">
                  DESPUÉS
                </p>
                <p className="font-heading font-bold text-5xl sm:text-6xl md:text-7xl text-white mb-2" data-id="element-80">
                  $35.730
                </p>
                <p className="text-green-300 font-body text-sm" data-id="element-81">
                  Con la guía aplicada
                </p>
              </div>
            </div>
          </a>
        </SectionReveal>

        <SectionReveal delay={0.25} data-id="element-82">
          <div className="text-center" data-id="element-83">
            <p className="text-2xl sm:text-3xl font-heading font-bold text-blue-400 mb-6" data-id="element-84">
              👉 Hasta un 60% menos en la factura
            </p>
            <p className="text-lg sm:text-xl text-gray-300 font-body leading-relaxed" data-id="element-85">
              Esto no es magia.
            </p>
            <p className="text-lg sm:text-xl text-gray-300 font-body leading-relaxed mb-8" data-id="element-86">
              Es entender qué está pasando y corregirlo.
            </p>
            <p className="text-sm text-gray-500 font-body text-center" data-id="element-87">
              Resultados reales pueden variar según el caso
            </p>
          </div>
        </SectionReveal>
      </div>
    </section>;
}